export default __webpack_public_path__ + "static/media/vt02.3596d4b2.jpg";